export default "__VITE_ASSET__DDO7f4a9__"